export class TimerService {
  private _startTime: Date
  private _elapsedTime: number = 0

  public constructor(private _offset: number = 0) {}

  public get elapsedTime() {
    return this._elapsedTime + this._offset
  }

  public tick() {
    const currentTime = new Date().getTime()
    this._elapsedTime = Math.floor((currentTime - this._startTime.getTime()) / 1000)
  }

  public start() {
    this._startTime = new Date()
  }

  public pause() {
    this._offset += this._elapsedTime
    this._elapsedTime = 0
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/timers/timer/timer.service.ts